import { Row } from '@components/Layout/Row';
import { useDispatchResize } from '@packages/hooks/useDispatchResize';
import { createMemo } from '@packages/react';
import React, { ElementType, HTMLAttributes, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { getPortalElement, renderMountChildren } from './utils';

interface MountToProps extends HTMLAttributes<HTMLDivElement> {
    to: string;
    name: string;
    component?: ElementType;
    children?: any;
    order?: number;
    zIndex?: number;
}

export const MountTo = createMemo<MountToProps>(
    (props): any => {
        const { children, component, name, to, order, zIndex, ...rest } = props;

        const portalPointRef = useRef<Element | null>(getPortalElement(to));
        const [checks, setChecks] = useState<number>(0);

        useEffect(() => {
            portalPointRef.current = getPortalElement(to);
            if (!portalPointRef.current) {
                setTimeout(() => setChecks(checks + 1), 50);
            } else {
                if (checks !== -1) {
                    setChecks(-1);
                }
            }
        }, [to, checks, portalPointRef.current]);

        useDispatchResize({ skipDrawer: true });

        if (!portalPointRef.current) {
            return null;
        }

        return createPortal(
            <RowWrap style={{ order, zIndex: zIndex || order }}>
                {renderMountChildren(children, component, rest)}
            </RowWrap>,
            portalPointRef.current,
        );
    },
    { displayName: 'MountTo' },
);
const RowWrap = styled(Row)`
    && {
        .MuiGrid-container {
            @media screen and (max-width: 426px) {
                flex-wrap: nowrap;
            }
            .MuiPaper-root {
                @media screen and (max-width: 360px) {
                    padding-left: 0;
                }
            }
        }
        .MuiIconButton-root {
            @media screen and (max-width: 360px) {
                padding: 12px 0 12px 0;
            }
        }
        .MuiGrid-root {
            @media screen and (max-width: 360px) {
                padding: 0;
            }
        }
    }
`;
